import { combineReducers } from "redux";
import * as locale from "./locale.reducer";
import * as cookieMessage from "./cookieMessage.reducer";
import * as deviceInfo from "./device-info.reducer";

export default combineReducers({
  locale: locale.reducer,
  cookieMessage: cookieMessage.reducer,
  deviceInfo: deviceInfo.reducer
});
